export default __webpack_public_path__ + "static/media/698.e8b16f71.png";